import { cn } from '@sohanemon/utils';
import { THEME_DEFINITIONS, type ThemeMode } from '@sohanscript/theme';
import { useResolvedTheme } from '@sohanscript/theme/store';
import { InjectColorFilter } from '@sohanscript/ui/color-filters';
import * as React from 'react';

type ThemeBackdropProps = React.ComponentProps<'div'> & {
	mode?: ThemeMode;
	mini?: boolean;
};

export function ThemeBackdrop({
	mode: theme,
	className,
	mini,
	...props
}: ThemeBackdropProps) {
	const _theme = useResolvedTheme();
	const mode = theme ?? _theme;
	const td = THEME_DEFINITIONS[mode];
	const backdrop = 'backdrop' in td ? td.backdrop : undefined;

	if (!backdrop?.layers.length) return null;

	return (
		<div
			key={mode}
			className={cn('pointer-events-none inset-0 overflow-hidden', className)}
			aria-hidden="true"
			{...props}
		>
			{td.color && <InjectColorFilter name={mode} color={td.preview.primary} />}
			{backdrop.layers.map((layer) => (
				<div
					key={layer.image}
					className={cn('absolute  inset-0', mini && 'last-of-type:hidden')}
					style={{
						filter: `url(#${mode}-color-filter)`,
						backgroundRepeat: 'no-repeat',
						mixBlendMode: layer.blend,
						backgroundImage: layer.image,
						backgroundPosition: mini ? 'bottom center' : layer.position,
						backgroundSize: mini ? 'min(32%, 20rem) auto' : layer.size,
						opacity: mini ? 1 : layer.opacity,
					}}
				/>
			))}
			<div
				className="absolute inset-0"
				style={{
					backgroundImage:
						'linear-gradient(to bottom, color-mix(in srgb, var(--background) 22%, transparent), color-mix(in srgb, var(--background) 58%, transparent) 58%, var(--background) 100%)',
				}}
			/>
		</div>
	);
}
